import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  Input,
  OnChanges,
  OnInit,
  Type,
  ViewContainerRef,
  Output,
  EventEmitter,
} from "@angular/core";

import { ImageComponent } from "../image/image.component";
import { TextComponent } from "../text/text.component";

import { ComponentInterface } from "../../models/component.interface";
import { ComponentConfig } from "../../models/component-config.interface";
import { IncassiInLavorazioneComponent } from "../incassi-in-lavorazione/incassi-in-lavorazione.component";
import { IncassiRendicontareComponent } from "../incassi-rendicontare/incassi-rendicontare.component";
import { BrogliacciIncassiComponent } from "../brogliacci-incassi/brogliacci-incassi.component";
import { IFrameComponent } from "../iFrame/iframe.component";
import { LinkComponent } from "../link/link.component";
import { ImageWithHtmlComponent } from "../image-with-html/image-with-html.component";
import { AnchorComponent } from "../anchor/anchor.component";
import { DocumentsComponent } from "../documents/documents.component";
import { StructuredDataComponent } from "../structured-data/structured-data.component";
import { EmptyComponent } from "../empty/empty.component";
import { DocumentsExternalSourceComponent } from "../documentsExternalSource/documentsExternalSource.component";

const components: { [type: string]: Type<ComponentInterface> } = {
  IFRAME: IFrameComponent,
  IMG: ImageComponent,
  HTML: TextComponent,
  INCASSI_LAV: IncassiInLavorazioneComponent,
  INCASSI_REND: IncassiRendicontareComponent,
  BROGLIACCI: BrogliacciIncassiComponent,
  DOWNLOAD: DocumentsComponent,
  LINK: AnchorComponent,
  STRUCTURED_DATA: StructuredDataComponent,
  HTTP_Data: StructuredDataComponent,
  image_with_html: ImageWithHtmlComponent,
  link: LinkComponent,
  DownloadExternalSource: DocumentsExternalSourceComponent,
  null: EmptyComponent,
};

@Directive({
  selector: "[appDynamic]",
})
export class DynamicDirective implements ComponentInterface, OnChanges, OnInit {
  @Input()
  config: any;
  // config: ComponentConfig;

  component: ComponentRef<ComponentInterface>;

  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) {}

  ngOnChanges() {
    if (this.component) {
      this.component.instance.config = this.config;
    }
  }

  ngOnInit() {
    if (!components[this.config.tipoBlocco]) {
      const supportedTypes = Object.keys(components).join(", ");
      throw new Error(
        `Trying to use an unsupported type (${this.config.tipoBlocco}).
        Supported types: ${supportedTypes}`
      );
    }
    const component = this.resolver.resolveComponentFactory<ComponentInterface>(
      components[this.config.tipoBlocco]
    );
    this.component = this.container.createComponent(component);
    this.component.instance.config = this.config;
    // this.component.instance.someProp = "prop";
  }

  checkRequired(): boolean {
    throw new Error("Method not implemented.");
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/dynamic/dynamic.directive.ts